export default __webpack_public_path__ + "static/media/290.f11839f8.jpg";